import { Button } from "@/components/Buttons";
import { TextField } from "@/components/Form/Parts/index";
import { useDeviceInfoQuery } from "@/hooks";
import formStyles from "@/styles/Form.module.scss";
import passwordResetStyles from "@/styles/PasswordReset.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var schema = y.object().shape({
  mailAddress: y.string().email("メールアドレスの形式で入力してください。").required("メールアドレスが入力されていません。")
});
export default function PasswordResetMailAddressForm(_ref) {
  var _errors$mailAddress;

  var onSubmit = _ref.onSubmit,
      handleBack = _ref.handleBack;

  var _useForm = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  }),
      formState = _useForm.formState,
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;
  var isWebView = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isWebView;
  var isDirty = formState.isDirty,
      isValid = formState.isValid,
      isSubmitting = formState.isSubmitting;
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsxs("p", {
          children: ["\u767B\u9332\u3057\u3066\u3044\u308BE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3059\u308B\u305F\u3081\u306E\u30EA\u30F3\u30AF\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002"]
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(TextField, {
            ref: register,
            title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09",
            type: "email",
            name: "mailAddress",
            placeholder: "\u534A\u89D2\u82F1\u6570\u5B57\u3067\u3054\u5229\u7528\u4E2D\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
            caption: "「@skyperfectv.co.jp」からのメールを受信できる様、ドメイン設定を解除して頂いただくか、又は弊社ドメイン『skyperfectv.co.jp』を 受信リストに加えていただきますよう、お願い申し上げます",
            error: (_errors$mailAddress = errors.mailAddress) === null || _errors$mailAddress === void 0 ? void 0 : _errors$mailAddress.message,
            required: true
          })
        }), /*#__PURE__*/_jsxs("p", {
          className: passwordResetStyles.noteText,
          children: ["\u203B\u3053\u306E\u753B\u9762\u304B\u3089\u300C", /*#__PURE__*/_jsx("a", {
            href: "https://my.skyperfectv.co.jp/login/",
            target: "_blank",
            children: "My\u30B9\u30AB\u30D1\u30FC\uFF01ID"
          }), "\u300D\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4\u306F\u3067\u304D\u307E\u305B\u3093\u3002"]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(formStyles.btnArea, " ").concat(formStyles.multiple, " ").concat(passwordResetStyles.btnArea),
      children: [!isWebView && /*#__PURE__*/_jsx(Button, {
        type: "button",
        fillGray: true,
        borderGray: true,
        fontFixed: true,
        onClick: handleBack,
        children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillColor: true,
        fontFixed: true,
        disabled: !isDirty || !isValid,
        loading: isSubmitting,
        children: "\u9001\u4FE1"
      })]
    })]
  });
}